import { Link } from "react-router-dom";
import { formatViews } from "@/lib/articles";
import type { Article } from "@/mocks/articles";

interface RankListProps {
  articles: Article[];
}

export default function RankList({ articles }: RankListProps) {
  return (
    <aside
      aria-label="热度排行"
      className="rounded-lg border border-background-200 bg-background-50 p-5"
    >
      <div className="flex items-center gap-2">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className="ri-bar-chart-fill" />
        </span>
        <h3 className="text-sm font-semibold text-foreground-950">热度排行</h3>
      </div>
      <ol className="mt-4 flex flex-col gap-1">
        {articles.map((article, index) => (
          <li key={article.id}>
            <Link
              to={`/detail/${article.id}`}
              className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
            >
              <span
                className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold ${
                  index < 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                  {article.title}
                </span>
                <span className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line" />
                  {formatViews(article.views)}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}